export default (initialState = {}) => {
  return () => {
    return {
      account_owner: undefined,
      associated_agent: undefined,
      categories: [],
      products: [],
      demand_broadcast: false,
      ...initialState,
    };
  };
};
